import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LandingNav from '../components/landing/LandingNav';
import MobileNavDrawer from '../components/landing/MobileNavDrawer';
import HeroSection from '../components/landing/sections/HeroSection';
import HowItWorksSection from '../components/landing/sections/HowItWorksSection';
import FeaturesSection from '../components/landing/sections/FeaturesSection';
import ExperienceSection from '../components/landing/sections/ExperienceSection';
import WhyChooseSection from '../components/landing/sections/WhyChooseSection';
import PricingSection from '../components/landing/sections/PricingSection';
import CtaSection from '../components/landing/sections/CtaSection';
import FooterSection from '../components/landing/sections/FooterSection';

const LandingPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openMobileMenu = useCallback(() => setMobileMenuOpen(true), []);
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  const scrollToSection = useCallback((sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setMobileMenuOpen(false);
  }, []);

  return (
    <Box component="main" sx={{ minHeight: '100vh', overflowX: 'hidden' }}>
      <LandingNav
        isAuthenticated={isAuthenticated}
        onNavigate={navigate}
        onScrollToSection={scrollToSection}
        onOpenMobileMenu={openMobileMenu}
      />
      <MobileNavDrawer
        open={mobileMenuOpen}
        onClose={closeMobileMenu}
        isAuthenticated={isAuthenticated}
        onNavigate={navigate}
        onScrollToSection={scrollToSection}
      />

      <HeroSection onNavigate={navigate} onScrollToSection={scrollToSection} />
      <HowItWorksSection />
      <FeaturesSection />
      <ExperienceSection />
      <WhyChooseSection />
      <PricingSection onNavigate={navigate} />
      <CtaSection onNavigate={navigate} onScrollToSection={scrollToSection} />
      <FooterSection onScrollToSection={scrollToSection} />
    </Box>
  );
};

export default LandingPage;
